import { render, staticRenderFns } from "./IconOpenInNew.vue?vue&type=template&id=d96587dc&"
import script from "./IconOpenInNew.vue?vue&type=script&lang=js&"
export * from "./IconOpenInNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports